import React from 'react';
import {
    Form,
    Input,
    Select,
    Row,
    Col,
    message,
    Tooltip,
    Button,
    Upload,
    Icon,
    Tabs,
    Radio,
} from 'antd';
import ModalDom from '../../../../components/Modal';
import TableDOM from '../../../../components/Table';
import DetailTitle from '../../../../components/DetailTitle';
import { post, postFrom, config, uploadEnclosure } from '../../../../axios';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { commonIsMap, dicMerchantStatus } from '../../../../axios/dictionaries';
import { formatTime } from '../../../../utils/index'
import axios from 'axios';
import './index.less'
import ImageView from '../../../../components/ImageView';
import SalesroomDetail from "../../../Salesroom/detail";
import MerchantSplitBill from './components/SplitBillView';

const Option = Select.Option;
const { TabPane } = Tabs
const { TextArea } = Input;

const fileMap = [ // 附件集合
    { attachType: 8, attachName: '原租赁合同、产权证明', files: [] },
    { attachType: 9, attachName: '入围房源清单、租客清单', files: [] },
    { attachType: 10, attachName: '营业执照、法人身份信息', files: [] },
    { attachType: 11, attachName: '征信及资产资料', files: [] },
    { attachType: 12, attachName: '白名单报告及担保函', files: [] },
    { attachType: 13, attachName: '其它', files: [] },
]

class MerchantAdd extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            params: {
                merchantNo: '', //商户编号
                merchantType: '1', //商户类型
                phone: '', //管理员手机
                password: '', //管理员密码
                userName: '',  //管理员姓名
                name: '', //全称
                shortName: '', //简称
                status: '' //使用状态
            },
            data: {},
            contractTemplate: [], //合同模板存储
            title: '新增商户', //标题名称
            id: '',
            contractData: [],
            newContractData: [],
            inputWidth: 200,
            labelWidth: 100,
            current: 1, //合同分页
            pageSize: 5,
            selectCheck: [], //多选框选中数组
            once: 1,
            contractArrPage: null, //当前合同页数
            tallyData: [], //商户电子模板合同暂存
            shouldPasswordRequired: true, //管理员密码是否必填
            passwordType: 'password',
            phoneCode: { second: 60, loading: false },
            fileMap,  // 附件集合
            apiLogData: { // logo数据
                total: 0,
                current: 1,
                list: []
            },
            projectData: { // 门店数据
                total: 0,
                current: 1,
                list: []
            },
            detailVisible: false,
            detailData: {},
            radioSyncValue:false,
            radioClarifyValue:false,
            radioZjbDataSyncValue:false,
            radioMessageRemindingValue:false,
            radioAutoReviewContract:false,
            radioDeviceLease:false
        }
        this.merchantContractSearch = this.merchantContractSearch.bind(this);
        this.handleContractSearch = this.handleContractSearch.bind(this);

    }
    componentDidMount() {
        this.props.onRef(this);
    }
    componentWillUnmount() {
        clearInterval(this.timer)
    }

    handleClarifyChange = (e) => { // 是否清算修改
        const radioClarifyValue = e.target.value
        this.setState({
            radioClarifyValue
        })
    }

    handleRadioSyncChange = (e) => { // 是否同步数据修改
        const radioSyncValue = e.target.value
        this.setState({
            radioSyncValue
        })
    }

    handleRadioZjbDataSyncChange= (e) =>{

        const radioZjbDataSyncValue = e.target.value
        this.setState({
            radioZjbDataSyncValue
        })



    }

   // messageReminding

    handleRadioMessageRemindingChange = (e) => { // 是否启用消息通知
        const radioMessageRemindingValue = e.target.value
        this.setState({
            radioMessageRemindingValue
        })
    }

    // messageReminding

    handleRadioDeviceLeaseChange = (e) => { // 是否设备租赁
        const radioDeviceLease = e.target.value
        this.setState({
            radioDeviceLease
        })
    }

    //autoReviewContract

    handleRadioAutoReviewContractChange = (e) => { // 是否合同自动审核通知
        const radioAutoReviewContract = e.target.value
        this.setState({
            radioAutoReviewContract
        })
    }





    handleCancel = () => {
        this.props.handleCancel();
        this.setState(state => {
            state.fileMap.map(e=> {
                e.files = []
                return e
            })
            return state
        })
        this.setState({ data: {}, loading: false, title: "新增商户", contractTemplate: [], selectCheck: [], current: 1 })
    }

    handleChange = (val) => {
        let { selectCheck, current } = this.state;
        selectCheck[current - 1] = val;
    }
    handlePhoneCodeGet() {
        if (this.state.phoneCode.second !== 60) {
            return
        }
        const name = this.props.form.getFieldValue('name') // 企业全称
        const account = this.props.form.getFieldValue('businessLicenseNo') // 企业营业执照号
        const mobile = this.props.form.getFieldValue('legalPersonPhone') // 企业法人手机号

        const legalPersonName = this.props.form.getFieldValue('legalPersonName') // 企业法人姓名
        const identity = this.props.form.getFieldValue('legalPersonCredentialNumber') // 企业法人证件号


        if(!name) {
            message.warn('请输入商户全称')
            return
        }

        if(!account) {
            message.warn('请输入企业营业执照号')
            return
        }
        if(!legalPersonName) {
            message.warn('请输入法人姓名')
            return
        }
        if (!mobile) {
            message.warn('请输入法人手机号')
            return
        }
        if(mobile.length !== 11) {
            message.warn('法人手机号输入不正确')
            return
        }
        if(!identity) {
            message.warn('请输入企业法人证件号')
            return
        }

        clearInterval(this.timer)
        this.setState(state => {
            state.phoneCode.loading = true
            return state
        })
        // 此处获取验证码之前 需要先预注册 ,成功后才可以获取验证码
        postFrom({
            url: config.API_merchant_prepCreate,
            data: { name, legalPersonName, legalPersonCredentialNumber:identity, legalPersonPhone: mobile, merchantNo: account, businessLicenseNo: account  }
        }).then(res => {
            return postFrom({
                url: config.API_merchant_getSmsCode,
                data: { name: legalPersonName, identity, mobile, account }
            })
        }).then(res => {
            this._setPhoneCodeSecond()
            message.success('获取成功');

            this.setState(state => {
                state.phoneCode.loading = false
                return state
            })

        }).catch(err => {
            message.error(err.message || '获取失败');
            this.setState(state => {
                state.phoneCode.loading = false
                return state
            })
        })
    }
    handleUpload(type, name, fileData) { // --- 上传附件

        this.setState(state => {
            state.fileMap.forEach(e => {
                if(e.attachType === type) {
                    e.files.push(fileData)
                }
            })

            return state
        })

    }
    _setPhoneCodeSecond() {
        this.timer = setInterval(() => {
            this.setState(state => {
                if(this.state.phoneCode.second === 0) {
                    state.phoneCode.second = 60
                    clearInterval(this.timer)
                } else {
                    state.phoneCode.second = --state.phoneCode.second
                }
                return state
            })
        }, 1000)
    }
    isCheckSms() {
        // 当新增 或 修改 商户全称、营业执照号、法人姓名、法人身份证、法人手机号的某个时 或者 identify4 不为真，出验证码
        const isAdd = this.state.shouldPasswordRequired
        const originForm = this.state.data
        const { getFieldValue } = this.props.form

        if (isAdd) {
            return true
        }
        if (!originForm.identify4) {
            return true
        }

        if (
            originForm.name !== getFieldValue('name') ||
            originForm.businessLicenseNo !== getFieldValue('businessLicenseNo') ||
            originForm.legalPersonName !== getFieldValue('legalPersonName') ||
            originForm.legalPersonCredentialNumber !== getFieldValue('legalPersonCredentialNumber') ||
            originForm.legalPersonPhone !== getFieldValue('legalPersonPhone')
        ) {
            return true
        }
        return false
    }
    loadPack = ({ id }) => {

        this.setState({ loading: true, title: "编辑商户", id, shouldPasswordRequired: false, passwordType: 'passwordNew' });
        let data = { merchantId: id };
        postFrom({
            url: config.API_merchant_getById,
            data,
        }).then(res => {
            this.setState({
                data: res,
                loading: false,
                radioClarifyValue: res.clarify === 1,
                radioMessageRemindingValue: res.messageReminding === 1,
                radioZjbDataSyncValue: res.zjbDataSync===1,
                radioSyncValue: res.dataSync===1,
                radioAutoReviewContract: res.autoReviewContract,
                radioDeviceLease: res.isDeviceLease===1
            });
            this.parseAttachToFormat(res)
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        })
        // this.merchantContractSearch({id});
    }


    passTypeUpdate = (newAdd) => {
        if (newAdd) {
            this.setState({ shouldPasswordRequired: true, passwordType: 'password' });
        } else {
            this.setState({ shouldPasswordRequired: false, passwordType: 'passwordNew' });
        }
    }
    parseAttachToIds = () => { // --- 附件 --> 吧state 中附件 转为 Ids
        let ids = []

        this.state.fileMap.forEach((e) => {
            e.files.forEach(ee => {
                ids.push(ee.attach_id)
            })
        })
        return ids
    }
    parseAttachToFormat = (formData) => { // --- 附件 --> 格式化 返回值
        this.setState(state => {
            state.fileMap.map(e => {


                const current = formData.attachList
                    .filter(ee => ee.attachType === e.attachType)
                    .map(ee => ({ attach_id: ee.id, attach_name: ee.fileName, attach_url: ee.fileUrl}))

                e.files = current

                return e
            })
            return state
        })
    }
    handleFileDelete = (index, childIndex) => { // --- 附件 --> 根据fileMap 的索引 删除
        this.setState(state => {
            state.fileMap[index].files.splice(childIndex,1)
            return state
        })
    }
    createFileView = (file, index, childIndex) => { // --- 附件 --> 根据src 返回 图片还是其它
        if(!file) {
            return
        }

        const imgfilter = ['.png', '.jpg', '.gif', '.jpeg']
        let isImg = false
        imgfilter.forEach((e) => {
            if(file.attach_url.indexOf(e) > -1){
                isImg = true
            }
        })
        if(isImg) {
            return <ImageView showPreview showDelete onDelete={this.handleFileDelete.bind(this,index,childIndex)} src={file.attach_url} mode="aspectFit" style={{width:120, height:120, border: '1px solid #eee'}} />
        }
        return (
            <div className="upload-box file" style={{margin:0}}>
                <Icon type="paper-clip" />
                <div className="mask">
                    <a href={file.attach_url} target="_blank">
                        <Icon type="eye" />
                    </a>
                    <Icon type="delete" onClick={this.handleFileDelete.bind(this,index,childIndex)} />
                </div>
            </div>
        )
    }
    merchantContractSearch = ({ id }) => { //商户电子合同查询

        this.setState({ loading: true })
        axios.all([
            postFrom({ url: config.API_contracttemplate_findAllContractTemplate, data: {} }), //系统电子合同模板
            postFrom({ url: config.API_merchantcontracttemplate_findPage, data: { merchantId: id } }) //商户电子合同模板
        ]).then(axios.spread((totalRes, listRes) => {

            let { selectCheck, pageSize } = this.state;
            let systemContract = totalRes;
            let merchantContract = listRes.records;
            let initContractArray = totalRes.slice(0, 5);
            let contractContainer = [];
            for (let i = 0; i < merchantContract.length; i++) { //电子合同初始化值
                if (merchantContract[i].contractTemplateId) {
                    contractContainer.push({
                        contractTemplateId: merchantContract[i].contractTemplateId
                    })
                }
            }

            for (let i = 0; i < merchantContract.length; i++) { //对应不同分页电子合同选中初始值
                for (let j = 0; j < systemContract.length; j++) {
                    if (systemContract[j].id === merchantContract[i].contractTemplateId) {
                        let index = Math.floor(j / pageSize);
                        if (selectCheck[index] instanceof Array) {
                            selectCheck[index].push(
                                merchantContract[i].contractTemplateId
                            )
                        } else {
                            selectCheck[index] = [merchantContract[i].contractTemplateId];
                        }

                    }
                }
            }
            this.setState({
                contractData: totalRes,
                newContractData: initContractArray,
                contractTemplate: contractContainer,
                loading: false,
                tallyData: merchantContract
            })

        })).catch(err => {
            message.error(err.message || '获取电子合同列表失败');
            this.setState({ loading: false });
        });
    }

    handleContractSearch = () => { //系统电子合同查询

        this.setState({ loading: true, shouldPasswordRequired: true })
        postFrom({
            url: config.API_contracttemplate_findAllContractTemplate,
            data: {}
        }).then(res => {
            let handleContractQuery = res.length;
            let initContractArray = res.slice(0, 5);
            let contractArrPage = Math.ceil(handleContractQuery / this.state.pageSize);
            this.setState({ contractData: res, newContractData: initContractArray, loading: false }, () => {
                if (this.once === 1) { //第一次进来创建
                    this.setState({
                        selectCheck: new Array(contractArrPage),
                        once: 0
                    })
                }
            });
        }).catch(err => {
            message.error(err.message || '获取系统电子合同列表失败');
            this.setState({ loading: false });
        })
    }


    handleOk = () => {

        this.props.form.validateFieldsAndScroll((error, values) => {
            if (error) {
                const errorMessage = Object.values(error)[0].errors[0].message
                message.error(errorMessage)
                return
            }
            // let merchantUserVo = {
            //     password: values.password
            //    ,phone: values.phone
            //    ,name: values.username
            // },
            let NOW_URL = '',
                responText = '',
                merchantContractTemplates = []; //合同id
            const { selectCheck, tallyData, data } = this.state;



            values.merchantType = 1; //默认为企业类型

            // delete values.phone
            // delete values.password
            // values.merchantUserVo = merchantUserVo;



            let concatSelect = [];
            for (let i = 0; i < selectCheck.length; i++) {
                concatSelect = concatSelect.concat(selectCheck[i])
            }

            if (this.props.handlecreateOrEdit) {
                NOW_URL = config.API_merchant_edit;
                responText = '编辑';
                values.id = this.state.id;
                values.adminUserId = data.adminUserId;
                values.housekeeperUserId=data.housekeeperUserId;

                for (let i = 0; i < concatSelect.length; i++) {
                    let outside = concatSelect[i];
                    let item = tallyData.find(item => item.contractTemplateId === outside)
                    if (item) {
                        merchantContractTemplates.push({
                            id: item.id,
                            contractTemplateId: outside
                        })
                    } else {
                        merchantContractTemplates.push({
                            contractTemplateId: outside
                        })
                    }
                }
            } else {
                NOW_URL = config.API_merchant_create;
                responText = '新增';
                for (let i = 0; i < selectCheck.length; i++) {
                    let outside = selectCheck[i];
                    for (let j = 0; j < outside.length; j++) {
                        merchantContractTemplates.push({
                            contractTemplateId: outside[j]
                        })
                    }
                }
            }
            values.dataSync=this.state.radioSyncValue?1:2;
            values.clarify=this.state.radioClarifyValue?1:2;
            values.messageReminding=this.state.radioMessageRemindingValue?1:2;
            values.isDeviceLease = this.state.radioDeviceLease?1:0;
            values.zjbDataSync=this.state.radioZjbDataSyncValue?1:2;
            //values.autoReviewContract = values.autoReviewContract;
            values.identify4 = !!this.state.data.identify4
            values.merchantContractTemplates = merchantContractTemplates;
            values.contactPhone = values.legalPersonPhone //联系人手机不用输入 ,读取法人手机 (by zhao 2019-12-24 )
            values.attachIdList = this.parseAttachToIds()
            const smsCode = values.smsCode
            delete values.smsCode
            post({
                url: NOW_URL + '?smsCode=' + (smsCode || ''),
                data: values
            }).then(res => {

                this.setState({ loading: false, contractTemplate: [], selectCheck: [], });
                this.props.handleGetList();
                this.handleCancel();
                message.success(`${responText}成功`);
            }).catch(err => {
                message.error(err.message || '接口异常');
                this.setState({ loading: false })
            })

        })
    }

    onChange = page => { //改变分页
        let { contractData, newContractData, pageSize, selectCheck } = this.state;
        newContractData = contractData.slice((page - 1) * pageSize);
        if (newContractData.length > pageSize) {
            newContractData = newContractData.slice(0, pageSize);
        }
        this.setState({ current: page, newContractData }, () => {
            this.props.form.setFieldsValue({ merchantContractTemplates: selectCheck[page - 1] })
        })
    };

    handleShowDetail = (record) => { // 打开详情
        this.setState({
            detailVisible: true,
            detailData: record
        })
    }

    handleProjectInfo(record) {
        console.log(record)
        this.SalesroomDetailRef.open(record.id,true);
    }


    handledetailCancel = () => { // 关闭详情
        this.setState({
            detailVisible: false
        })
    }

    postApilogFindPage = ({ id, current }) => { // 获取 apilog 记录
        const { apiLogData } = this.state
        const rowId = id || this.merchatId
        this.merchatId = rowId
        const data = { rowId, tableName: 'Merchant', current: current || apiLogData.current, pageSize: 10 }
        postFrom({
            url: config.API_apilog_findPage,
            data,
        }).then(res => {
            const { current, total, records } = res
            this.setState({
                apiLogData: {
                    current,
                    total,
                    list: records
                }
            })
        }).catch(err => {
            message.error(err.message || '获取列表失败!')
        })
    }
    postProjectFindPage = ({ id, current }) => { // 获取商户门店数据
        const { projectData } = this.state
        const rowId = id || this.merchatId
        this.merchatId = rowId
        const data = { merchantId:rowId,  current: current || projectData.current, pageSize: 10 }
        post({
            url: config.API_salesroom_findPage,
            data,
        }).then(res => {
            const { projectCurrent, projectTotal, records } = res
            this.setState({
                projectData: {
                    projectCurrent,
                    projectTotal,
                    projectList: records
                }
            })
        }).catch(err => {
            message.error(err.message || '获取列表失败!')
        })
    }

    render() {
        const modalFooter = {}
        if(this.props.onlyRead){
            modalFooter.footer = <Button onClick={this.handleCancel}>关闭</Button>
        }
        let { visible, form: { getFieldDecorator, getFieldValue } } = this.props;
        let { loading, data, title, labelWidth, shouldPasswordRequired, detailData } = this.state;
        const { current, total, list } = this.state.apiLogData
        const { projectCurrent, projectTotal, projectList } = this.state.projectData

        const formItemLayout = {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 3 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 20 },
            },
          };

        const apilogColumns = [
            { title: '接口名称', dataIndex: 'apiName' },
            // {
            //     title: '接口类型', dataIndex: 'apiType',
            //     render(text) {
            //         if (!text) return '-'
            //         const item = apiType.find(item => item.value === text)
            //         if (!item) return '-'
            //         return item.title
            //     }
            // },
            { title: 'url', dataIndex: 'url' },
            // { title: '参数值', dataIndex: 'params' },
            {
                title: '调用时间', dataIndex: 'callTime',
                render(text) {
                    if (!text) return '-'
                    return formatTime(text)
                }
            },
        ]

        const projectColumns = [
                { title: '门店名称', dataIndex: 'projectName' },
                { title: '联系电话', dataIndex: 'serviceTel' },
                { title: '所属楼栋', dataIndex: 'buildingName' },
                {
                    title: '同步状态 | 建融Id',
                    dataIndex: 'name33',
                    render(text, record, index) {
                        return <span>
                    <div>{record.jrProjectId ? "同步成功" : "未同步"}</div>
                            {
                                record.jrProjectId
                                    ? <React.Fragment>
                                        <div>{record.jrProjectId ? record.jrProjectId : ''}</div>
                                    </React.Fragment>
                                    : null
                            }
                </span>
                    }
                },
                { title: '门店封面', dataIndex: 'coverPicture', render: (text) => {
                        return <img src={text} style={{width:30, height:30}} alt="" />
                    }},
        ]


        const subAccount = getFieldValue('subAccount')

        const ledgerAllocationListValidator = (rule, value, callback) => {
            if(!value || value.length === 0) {
               return callback('请添加分账配置')
            }
            let accumulation = 0
            for(let i = 0; i< value.length; i++) {
                if (!value[i].mid) {
                    return callback('分账配置商户号不能为空')
                }
                if (!value[i].scale) {
                    return callback('分账配置分账比例不能为空')
                }
                if (value[i].scale <= 0) {
                    return callback('分账配置分账比例必须大于0')
                }
                if (value[i].scale > 1) {
                    return callback('分账配置分账比例必须小于等于1')
                }
                accumulation+= value[i].scale
            }
            if (accumulation > 1) {
                return callback('分账配置分账比例累加必须小于等于1')
            }
            if (accumulation < 0.7) {
                return callback('分账配置分账比例累加必须大于等于0.7')
            }
            return callback()
        }

        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            width="660px"
            onOk={this.handleOk}
            {...modalFooter}
            onCancel={this.handleCancel}
               >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                    className="min-height"
                >
                    <Row>
                        <Col span={24}  >
                            <DetailTitle boxStyle={{ marginTop: 0 }} title="基本信息" />
                            <CustomRow >
                                <CustomCol labelStyle={{ width: labelWidth }} label="商户编号">
                                    {getFieldDecorator('merchantNo', {
                                        rules: [{
                                            required: true, message: '请输入商户编号',
                                        }],
                                        initialValue: data.merchantNo
                                    })(
                                        <Input
                                            placeholder={'请输入'}

                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>

                                <CustomCol labelStyle={{ width: labelWidth }} label="使用状态">
                                    {getFieldDecorator('status', {
                                        rules: [{
                                            required: true, message: '请选择使用状态',
                                        }],
                                        initialValue: data.status || 1
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"

                                            optionFilterProp={'children'}
                                        >
                                            {dicMerchantStatus.map((item, index) => <Option key={index} value={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>




                            </CustomRow>

                            <CustomRow divider>
                                <CustomCol colStyle={{ width: "501px" }} labelStyle={{ width: labelWidth }} label="商户全称">
                                    {getFieldDecorator('name', {
                                        rules: [{
                                            required: true, message: '请输入商户全称',
                                        }],
                                        initialValue: data.name
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>


                            <CustomRow divider>

                                <CustomCol labelStyle={{ width: labelWidth }} label="商户简称">
                                    {getFieldDecorator('shortName', {
                                        rules: [{
                                            required: true, message: '请输入商户简称',
                                        }],
                                        initialValue: data.shortName
                                    })(
                                        <Input
                                            placeholder={'请输入'}

                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>

                                <CustomCol labelStyle={{ width: labelWidth }} label="营业执照号">
                                    {getFieldDecorator('businessLicenseNo', {
                                        rules: [{
                                            required: true, message: '请输入营业执照号',
                                        }],
                                        initialValue: data.businessLicenseNo
                                    })(
                                        <Input
                                            placeholder={'请输入'}

                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>

                            <CustomRow divider>

                                <CustomCol labelStyle={{ width: labelWidth }} label="法人姓名">
                                    {getFieldDecorator('legalPersonName', {
                                        rules: [{
                                            required: true, message: '请输入法人姓名',
                                        }],
                                        initialValue: data.legalPersonName
                                    })(
                                        <Input
                                            placeholder={'请输入'}

                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>

                                <CustomCol labelStyle={{ width: labelWidth }} label="法人身份证">
                                    {getFieldDecorator('legalPersonCredentialNumber', {
                                        rules: [{
                                            required: true, message: '请输入身份证号',
                                        }],
                                        initialValue: data.legalPersonCredentialNumber
                                    })(
                                        <Input
                                            placeholder={`请输入`}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>


                            <CustomRow divider>

                                <CustomCol labelStyle={{ width: labelWidth }} label="法人手机号">
                                    {getFieldDecorator('legalPersonPhone', {
                                        rules: [{
                                            required: true, message: '请输入法人手机号',
                                        }],
                                        initialValue: data.legalPersonPhone
                                    })(
                                        <Input
                                            placeholder={'请输入'}

                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                {this.isCheckSms() &&
                                    <Button
                                        style={{height:36,marginLeft:5,boxSizing:'border-box'}}
                                        ghost
                                        type="primary"
                                        onClick={this.handlePhoneCodeGet.bind(this)}
                                        loading={this.state.phoneCode.loading}
                                    >{this.state.phoneCode.second === 60 ? '获取验证码' : (this.state.phoneCode.second + 's')}</Button>
                                }


                                {/* <CustomCol labelStyle={{ width: labelWidth }} label="联系人手机">
                                    {getFieldDecorator('contactPhone', {
                                        rules: [{
                                            required: true, message: '请输入联系手机',
                                        }],
                                        initialValue: data.contactPhone
                                    })(
                                        <Input
                                            placeholder={`请输入`}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol> */}
                                {/* <CustomCol labelStyle={{ width: labelWidth }} label="管理员姓名">
                                    {getFieldDecorator('legalPersonName', {
                                        rules: [{
                                            required: true, message: '请输入管理员姓名',
                                        }],
                                        initialValue: data.legalPersonName
                                    })(
                                        <Input
                                            placeholder={'请输入'}

                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol> */}
                            </CustomRow>
                            {this.isCheckSms() && <CustomRow divider>
                                <CustomCol labelStyle={{ width: labelWidth }} label="验证码">
                                    {getFieldDecorator('smsCode', {
                                        rules: [{
                                            required: true, message: '请输入验证码',
                                        }],
                                    })(
                                        <Input
                                            placeholder={`请输入`}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>}

                            <CustomRow divider>

                                <CustomCol labelStyle={{ width: labelWidth }} label="管理员姓名">
                                    {getFieldDecorator('userName', {
                                        rules: [{
                                            required: true, message: '请输入管理员姓名',
                                        }],
                                        initialValue: data.userName
                                    })(
                                        <Input
                                            placeholder={'请输入'}

                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>

                                <CustomCol labelStyle={{ width: labelWidth }} label="管理员手机">
                                    {getFieldDecorator('phone', {
                                        rules: [{
                                            required: true, message: '请输入管理员手机',
                                        }],
                                        initialValue: data.phone
                                    })(
                                        <Input
                                            placeholder={'请输入'}

                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>

                            </CustomRow>

                            <CustomRow divider>

                                <CustomCol labelStyle={{ width: labelWidth }} required={shouldPasswordRequired ? undefined : false} label="管理员密码">
                                    {getFieldDecorator('password', {
                                        rules: [{
                                            required: shouldPasswordRequired, message: '请输入管理员密码',
                                        }]
                                    })(
                                        <Input
                                            placeholder={`请输入`}

                                            type="password"
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="对接建行">
                                {getFieldDecorator('isJr', {
                                    rules: [{
                                        required: true, message: '请输入',
                                    }],
                                    initialValue: data.isJr || 2
                                })(
                                    <Select
                                        showSearch
                                        placeholder="请选择"
                                        optionFilterProp={'children'}
                                    >
                                        {commonIsMap.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                    </Select>
                                )}
                            </CustomCol>

                            </CustomRow>

                            <CustomRow divider>

                                <CustomCol labelStyle={{ width: labelWidth }} label="派驻管家姓名">
                                    {getFieldDecorator('housekeeperName', {
                                        rules: [{
                                            required: true, message: '请输入派驻管家姓名',
                                        }],
                                        initialValue: data.housekeeperName
                                    })(
                                        <Input
                                            placeholder={'请输入派驻管家姓名'}

                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>

                                <CustomCol labelStyle={{ width: labelWidth }} label="派驻管家手机">
                                    {getFieldDecorator('housekeeperPhone', {
                                        rules: [{
                                            required: true, message: '请输入派驻管家手机',
                                        }],
                                        initialValue: data.housekeeperPhone
                                    })(
                                        <Input
                                            placeholder={'请输入派驻管家手机'}

                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>

                            </CustomRow>

                            <CustomRow divider>

                                <CustomCol labelStyle={{ width: labelWidth }} required={shouldPasswordRequired ? undefined : false} label="派驻管家密码">
                                    {getFieldDecorator('housekeeperPassword', {
                                        rules: [{
                                            required: shouldPasswordRequired, message: '请输入派驻管家密码',
                                        }]
                                    })(
                                        <Input
                                            placeholder={`请输入派驻管家密码`}

                                            type="password"
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>

                            <CustomRow divider>

                                <CustomCol label="启用消息提醒">
                                    {getFieldDecorator('messageReminding', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: (data.messageReminding==null?false: (data.messageReminding===1?true:false))
                                    })(
                                        <Radio.Group onChange={this.handleRadioMessageRemindingChange}>
                                            <Radio value={false}>否</Radio>
                                            <Radio value>是</Radio>
                                        </Radio.Group>
                                        /* <Select
                                             showSearch
                                             placeholder="请选择"
                                             optionFilterProp={'children'}
                                         >
                                             {commonIsMap.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                         </Select>*/
                                    )}
                                </CustomCol>
                                <CustomCol label="租金宝数据">
                                    {getFieldDecorator('zjbDataSync', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: (data.zjbDataSync==null?false: (data.zjbDataSync===1?true:false))
                                    })(
                                        <Radio.Group onChange={this.handleRadioZjbDataSyncChange}>
                                            <Radio value={false}>关闭同步</Radio>
                                            <Radio value>开启同步</Radio>
                                        </Radio.Group>
                                        /* <Select
                                             showSearch
                                             placeholder="请选择"
                                             optionFilterProp={'children'}
                                         >
                                             {commonIsMap.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                         </Select>*/
                                    )}
                                </CustomCol>
                            </CustomRow>


                            <CustomRow divider>

                                <CustomCol label="合同自动审核">
                                    {getFieldDecorator('autoReviewContract', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: (data.autoReviewContract==null?false: (data.autoReviewContract))
                                    })(
                                        <Radio.Group onChange={this.handleRadioAutoReviewContractChange}>
                                            <Radio value={false}>否</Radio>
                                            <Radio value={true}>是</Radio>
                                        </Radio.Group>
                                    )}
                                </CustomCol>
                                <CustomCol label="是否设备租赁">
                                    {getFieldDecorator('isDeviceLease', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: (data.isDeviceLease==null?false: (data.isDeviceLease===1?true:false))
                                    })(
                                        <Radio.Group onChange={this.handleRadioDeviceLeaseChange}>
                                            <Radio value={false}>否</Radio>
                                            <Radio value={true}>是</Radio>
                                        </Radio.Group>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="银联商户号" required={false}>
                                    {getFieldDecorator('ylMid', {
                                        rules: [{
                                            required: false, message: '请输入银联主商户号',
                                        }],
                                        initialValue: data.ylMid
                                    })(
                                        <Input
                                            placeholder={'请输入'}

                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="银联终端号" required={false}>
                                    {getFieldDecorator('ylTid', {
                                        rules: [{
                                            required: false, message: '请输入银联终端号',
                                        }],
                                        initialValue: data.ylTid
                                    })(
                                        <Input
                                            placeholder={'请输入'}

                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>

                            <DetailTitle boxStyle={{ marginTop: 20 }} title="分账信息" />
                            <CustomRow>
                              <CustomCol labelStyle={{ width: labelWidth }} label="是否分账">
                                {getFieldDecorator('subAccount', {
                                  rules: [{ required: true, message: '请选择是否分账' }],
                                  initialValue: data.subAccount
                                })(
                                  <Radio.Group >
                                    <Radio value={false}>否</Radio>
                                    <Radio value>是</Radio>
                                  </Radio.Group>
                                )}
                              </CustomCol>
                            </CustomRow>
                            {
                              subAccount ? (
                                getFieldDecorator('ledgerAllocationList', {
                                    rules: [
                                        { required: true, message: '请选择是否清算' },
                                        { validator: ledgerAllocationListValidator }
                                    ],
                                    initialValue: data.ledgerAllocationList
                                })( <MerchantSplitBill /> )
                              ) : null
                            }
                            {
                             this.state.radioZjbDataSyncValue?<DetailTitle boxStyle={{marginTop: 20}} title="清算信息"/>:null}
                            {
                                this.state.radioZjbDataSyncValue? <CustomRow>
                                <CustomCol labelStyle={{width: labelWidth}} label="是否清算">
                            {getFieldDecorator('clarify', {
                                rules: [{required: true, message: '请选择是否清算'}],
                                initialValue: data.clarify === 1
                            })(
                                <Radio.Group onChange={this.handleClarifyChange}>
                                <Radio value={false}>否</Radio>
                                <Radio value>是</Radio>
                                </Radio.Group>
                                )}
                                </CustomCol>
                                </CustomRow>:null
                            }
                            {
                                this.state.radioClarifyValue ? (
                                    <CustomRow divider>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="开户行网点号">
                                            {getFieldDecorator('balanceAccBankNo', {
                                                rules: [{ required: true, message: '请输入开户行网点号' }],
                                                initialValue: data.balanceAccBankNo || ''
                                            })(
                                                <Input
                                                    placeholder="请输入"
                                                />
                                            )}
                                        </CustomCol>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="账户户名" extra="提示">
                                            {getFieldDecorator('balanceAccName', {
                                                rules: [{ required: true, message: '请输入账户户名' }],
                                                initialValue: data.balanceAccName || ''
                                            })(
                                                <Input
                                                    placeholder="请输入"
                                                />
                                            )}
                                        </CustomCol>

                                    </CustomRow>
                                ) : null
                            }

                            {
                                this.state.radioClarifyValue ? (
                                    <CustomRow divider>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="账户账号" extra="提示">
                                            {getFieldDecorator('balanceAcc', {
                                                rules: [{ required: true, message: '请输入账户账号' }],
                                                initialValue: data.balanceAcc || ''
                                            })(
                                                <Input
                                                    placeholder="请输入"
                                                />
                                            )}
                                        </CustomCol>
                                    </CustomRow>
                                ):null
                            }

                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <div style={{height:30}} />
                            {/* <DetailTitle boxStyle={{ marginTop: 0 }} title="附件" /> */}

                            <Tabs defaultActiveKey="1">
                                <TabPane tab="附件" key="1">
                                    <div>
                                        {
                                            this.state.fileMap.map((e,i) => (
                                                <div className="file-item" key={'file-' + i}>
                                                    <div className="label">{e.attachName}</div>
                                                    <div className="value">
                                                        <Upload {...uploadEnclosure({ accept: '*', tableName: 'merchant', success: this.handleUpload.bind(this, e.attachType), attachType: e.attachType, rowId: this.state.id || 0 })}>
                                                            <div className="upload-box">
                                                                <Icon type="plus" />
                                                            </div>
                                                        </Upload>
                                                        {e.files.map((ee,ii) => {
                                                            return (
                                                                <div className="img-wrap" key={'file-' + i + '-' + ii} >
                                                                    {this.createFileView(ee, i, ii)}
                                                                    <Tooltip title={ee.attach_name} >
                                                                        <div className="filename">{ee.attach_name}</div>
                                                                    </Tooltip>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </TabPane>
                                <TabPane tab="接口日志" key="2">
                                    <TableDOM
                                        columns={apilogColumns}
                                        data={list}
                                        loading={false}
                                        total={total}
                                        current={current}
                                        onChange={this.postApilogFindPage}
                                        onRow={record => {
                                            return {
                                              onClick: event => { this.handleShowDetail(record) },
                                            };
                                        }}
                                    />
                                </TabPane>
                                <TabPane tab="门店" key="3">
                                    <TableDOM
                                        columns={projectColumns}
                                        data={projectList}
                                        loading={false}
                                        total={projectTotal}
                                        current={projectCurrent}
                                        onChange={this.postProjectFindPage}
                                        onRow={record => {
                                            return {
                                                onClick: event => { this.handleProjectInfo(record) },
                                            };
                                        }}
                                    />
                                </TabPane>
                            </Tabs>
                        </Col>
                    </Row>

                    {/* <DetailTitle title="收款账户" />
                    <Row>
                        <Col span={24}  >
                            <CustomRow>
                                <CustomCol required={'不必填'} label="微信APPID">
                                    {getFieldDecorator('collectionAccount', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        // initialValue:
                                    })(
                                        <Input
                                            placeholder={'请输入'}

                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>

                        </Col>
                    </Row> */}
                    {/*
                    <DetailTitle title="电子合同" />
                    <Form.Item style={{ margin: 0, padding: 0 }}>
                        {getFieldDecorator('merchantContractTemplates', {
                            rules: [{
                                required: true, message: '请选择电子合同',
                            }],
                            initialValue: contractTemplate.length != 0 ?  contractTemplate.map((item)=> {
                                return item.contractTemplateId
                            }): undefined
                        })(
                            <CheckboxGroup style={{ display: 'block' }} onChange={ this.handleChange }>
                                <div className="tableBox">
                                    <div className="tableTitle">
                                        <div style={{ flex: '0 0 100px' }}>选择</div>
                                        <div style={{ flex: 1 }}>合同编号</div>
                                        <div style={{ flex: 1 }}>合同名称</div>
                                        <div style={{ flex: 1 }}>操作</div>
                                    </div>
                                    <div className="tableBody">
                                        {
                                            this.state.newContractData.length
                                                    ? this.state.newContractData.map((item, index) => {
                                                        if (item) {
                                                            return <label className="tableBodyRow" key={index}>
                                                                <div style={{ flex: '0 0 100px', alignItems: 'center' }}><Checkbox key={index} value={item.id}></Checkbox></div>
                                                                <div style={{ flex: 1 }}>{item.id}</div>
                                                                <div style={{ flex: 1 }}>{item.name}</div>
                                                                <div style={{ flex: 1, textDecoration: 'underline' }}><span className="showClickDetail" onClick={e => { e.preventDefault(); }}>查看合同</span></div>
                                                            </label>
                                                        }
                                                    })
                                                    : <div className="tableBodyRow" style={{ justifyContent: 'center' }}>暂无数据</div>
                                        }
                                    </div>
                                </div>
                            </CheckboxGroup>
                        )}
                         {
                                    contractData.length
                                        ? <div style={{ padding: '10px 0', textAlign: 'right' }}>
                                            <Pagination
                                                size="small"
                                                current={this.state.current}
                                                pageSize={this.state.pageSize}
                                                onChange={this.onChange}
                                                total={contractData.length}
                                            />
                                        </div>
                                        : null
                                }
                    </Form.Item> */}
                </Form>
            </div>

            <ModalDom
                title="日志详情"
                visible={this.state.detailVisible}
                loading={false}
                width="660px"
                onOk={this.handleOk}
                footer={<Button onClick={this.handledetailCancel}>关闭</Button>}
                onCancel={() => { this.setState({ detailVisible: false }) }}
            >
                <Form>
                    <Form.Item {...formItemLayout} label="接口url">
                        {getFieldDecorator('url', {
                            initialValue: detailData.url
                        })(
                            <Input
                                autoComplete={'off'}
                            />
                        )}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="接口参数">
                        {getFieldDecorator('params', {
                            initialValue: detailData.params
                        })(
                            <TextArea
                                autoComplete={'off'}
                            />
                        )}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="接口返回值">
                        {getFieldDecorator('response', {
                            initialValue: detailData.response
                        })(
                            <TextArea
                                autoComplete={'off'}
                            />
                        )}
                    </Form.Item>
                </Form>
            </ModalDom>

            <SalesroomDetail wrappedComponentRef={ ref=> this.SalesroomDetailRef = ref } />

        </ModalDom>

    }
}

export default Form.create()(MerchantAdd);



// WEBPACK FOOTER //
// ./src/page/Merchant/components/ManageAdd/index.js